import { AbstractEffect } from './abstract.effect'

export class TransformEffect extends AbstractEffect {
  static metaInfo() {
    return {
      uuid: 'transform',
      code: 'transform',
      name: 'Transform',
      apply: ['text', 'image', 'video', 'd3']
    }
  }

  constructor(suuid, uuid) {
    super(suuid, uuid)
    this._math = '+'
    this._controls = {}
  }

  info() {
    const ret = super.info()
    ret.math = this._math
    ret.controls = this._controls
    return ret
  }

  configure(data) {
    super.configure(data)
    this._math = typeof data.math === 'undefined' ? this._math : data.math
    this._controls = data.controls || this._controls
  }

  frame(time, props) {
    const next = { ...props }
    Object.keys(this._controls || {}).forEach(prop => {
      if (!this._controls[prop] || this._controls[prop] === 'none') return
      const val = this.value(time, this._controls[prop])
      if (this._math === '=')
        next[prop] = val
      if (this._math === '+')
        next[prop] = next[prop] + val
      if (this._math === '*')
        next[prop] = next[prop] * val
      if (this._math === '%')
        next[prop] = next[prop] * val / 100
    })
    return next
  }
}
